import { createSlice } from "@reduxjs/toolkit";
import { reducerRegistry } from "@/utils/redux";
import { initialState, reducers } from "./reducers";

const slice = createSlice({
  name: "HotTopics",
  initialState,
  reducers,
});

export const { actions, reducer } = slice;
export const { getHotTopics, getHotTopicsError, getHotTopicsSuccess } =
  slice.actions;

reducerRegistry.register("hotTopics", reducer);
